import { ISonicWordmark } from "assets";
import ISonicLogo from "assets/contentCreator/ISonicLogo";

const WORDMARK_ASPECT_RATIO = 188 / 60;

export default function AskLogo({
  size = 36,
  fill = false,
  variant = "wordmark",
  className = "",
}) {
  if (variant === "icon") {
    return (
      <span
        className={`cm-logo ${className}`.trim()}
        style={{ display: "inline-flex", width: size, height: size }}
        aria-label="iSonic"
        role="img"
      >
        <ISonicLogo size={size} contrastColor="currentColor" />
      </span>
    );
  }

  if (fill) {
    return (
      <span
        className={`cm-logo ${className}`.trim()}
        style={{ display: "block", width: "100%" }}
        aria-label="iSonic Alpha"
        role="img"
      >
        <ISonicWordmark
          preserveAspectRatio="xMinYMid meet"
          style={{ display: "block", width: "100%", height: "auto" }}
        />
      </span>
    );
  }

  const width = size * WORDMARK_ASPECT_RATIO;

  return (
    <span
      className={`cm-logo ${className}`.trim()}
      style={{ display: "inline-flex", width, height: size }}
      aria-label="iSonic Alpha"
      role="img"
    >
      <ISonicWordmark
        preserveAspectRatio="xMinYMid meet"
        style={{ width: "100%", height: "100%" }}
      />
    </span>
  );
}
